// extracted by mini-css-extract-plugin
module.exports = {"aiWatermarkModal":"U0hiUd0G","content":"_6qbg2VC","secondaryText":"LJsvoho_","link":"G2MkszAE"};